import React, { Component } from 'react';
import { headers, BaseURLDev } from '../../../../../_utils/config';
import { toIDR } from '../../../../../_utils/tocurrency';
import { Form, Loader,  Select, Button, Segment, Menu, Icon, Message } from 'semantic-ui-react';
import printJS from 'print-js';
import moment from 'moment'
import jsPDF from 'jspdf'
import 'jspdf-autotable';
import { getOPD } from '../../../../../_utils/localstorage';

export default class SPJPendapatan extends Component {
    constructor(props){
        super(props);
        this.state = {
            all_data: [],
            requests: false,
            kuasas: '',
            parafs: '',
            kuasa: '',
            kuasan: '',
            kuasaj: '',
            paraf: '', 
            parafn: '', 
            tot1: 0,
            tot2: 0,
            tot3: 0,
            tot4: 0,
            tot5: 0,
            tot6: 0,
            tot7: 0,
            tot8: 0,
            tot9: 0,
            tot10: 0,
            tempat: "",

            opd: "",
            skpd: "",
            bulan: {},
            bulanSekarang: "",
        }
        this.getAllData = this.getAllData.bind(this);
        this.onChangeKuasa = this.onChangeKuasa.bind(this);
        this.onChangeParaf = this.onChangeParaf.bind(this); 
        this.onChangeTempat = this.onChangeTempat.bind(this); 
        this.onChangeBulan = this.onChangeBulan.bind(this);    
    }

    onChangeBulan(e, el){
        this.setState({ requests: true })
        fetch(`${BaseURLDev}/report/spjadministratif?month=${el.value}`, { headers })
        .then(response => {
            if(!response.ok){
                this.setState({
                    requests: false
                })
                return Promise.reject(response.statusText);
            }
            return response.json()
        })
        .then(resJSON => {
            var tot1=0; var tot2=0; var tot3=0; var tot4=0; var tot5=0; var tot6=0; var tot7=0;
            var tot8=0; var tot9=0; var tot10=0;
            for(var i=0;i<resJSON.data.rekening.length;i++){
                if(resJSON.data.rekening[i]['kalkulasi']['sd_bulan_lalu']['penerimaan'] !==0 ||
                resJSON.data.rekening[i]['kalkulasi']['sd_bulan_lalu']['penyetoran'] !==0  ||
                resJSON.data.rekening[i]['kalkulasi']['sd_bulan_lalu']['sisa'] !==0  ||
                resJSON.data.rekening[i]['kalkulasi']['bulan_ini']['penerimaan'] !==0  ||
                resJSON.data.rekening[i]['kalkulasi']['bulan_ini']['penyetoran'] !==0  ||
                resJSON.data.rekening[i]['kalkulasi']['bulan_ini']['sisa'] !==0  ||
                resJSON.data.rekening[i]['kalkulasi']['sd_bulan_ini']['penerimaan'] !==0  ||
                resJSON.data.rekening[i]['kalkulasi']['sd_bulan_ini']['penyetoran'] !==0  ||
                resJSON.data.rekening[i]['kalkulasi']['sd_bulan_ini']['sisa'] !==0){
                    tot1=tot1+resJSON.data.rekening[i].anggaran;
                }
                tot2=tot2+resJSON.data.rekening[i]['kalkulasi']['sd_bulan_lalu']['penerimaan'];
                tot3=tot3+resJSON.data.rekening[i]['kalkulasi']['sd_bulan_lalu']['penyetoran'];
                tot4=tot4+resJSON.data.rekening[i]['kalkulasi']['sd_bulan_lalu']['sisa'];
                tot5=tot5+resJSON.data.rekening[i]['kalkulasi']['bulan_ini']['penerimaan'];
                tot6=tot6+resJSON.data.rekening[i]['kalkulasi']['bulan_ini']['penyetoran'];
                tot7=tot7+resJSON.data.rekening[i]['kalkulasi']['bulan_ini']['sisa'];
                tot8=tot8+resJSON.data.rekening[i]['kalkulasi']['sd_bulan_ini']['penerimaan'];
                tot9=tot9+resJSON.data.rekening[i]['kalkulasi']['sd_bulan_ini']['penyetoran'];
                tot10=tot10+resJSON.data.rekening[i]['kalkulasi']['sd_bulan_ini']['sisa'];
            }
            this.setState({
                all_data: resJSON.data.rekening,
                opd: resJSON.data.opd,
                skpd: resJSON.data.skpd,
                requests: false,
                tot1: tot1,
                tot2: tot2,
                tot3: tot3,
                tot4: tot4,
                tot5: tot5,
                tot6: tot6,
                tot7: tot7,
                tot8: tot8,
                tot9: tot9,
                tot10: tot10,
                bulanSekarang: this.state.bulan.find(nama => nama.value === el.value).text
            })
        })
    }

    onChangeTempat(e, el){
        this.setState({
            tempat:el.value,
        })
     }

    onChangeKuasa(e, el){
        this.setState({
            kuasa: this.state.kuasas.find(nama => nama.value === el.value).key,
            kuasan: this.state.kuasas.find(nama => nama.value === el.value).text,
            kuasaj: this.state.kuasas.find(nama => nama.value === el.value).value
        })
     }
     onChangeParaf(e, el){
        this.setState({
           paraf: el.value,
           parafn: this.state.parafs.find(nama => nama.key === el.value).text
        })
     }

    getAllData(){
        this.setState({ requests: true })
        fetch(`${BaseURLDev}/report/spjadministratif`, { headers })
        .then(response => {
            if(!response.ok){
                this.setState({
                    requests: false
                })
                return Promise.reject(response.statusText);
            }
            return response.json()
        })
        .then(resJSON => {
            var tot1=0; var tot2=0; var tot3=0; var tot4=0; var tot5=0; var tot6=0; var tot7=0;
            var tot8=0; var tot9=0; var tot10=0;
            for(var i=0;i<resJSON.data.rekening.length;i++){
                if(resJSON.data.rekening[i]['kalkulasi']['sd_bulan_lalu']['penerimaan'] !==0 ||
                resJSON.data.rekening[i]['kalkulasi']['sd_bulan_lalu']['penyetoran'] !==0  ||
                resJSON.data.rekening[i]['kalkulasi']['sd_bulan_lalu']['sisa'] !==0  ||
                resJSON.data.rekening[i]['kalkulasi']['bulan_ini']['penerimaan'] !==0  ||
                resJSON.data.rekening[i]['kalkulasi']['bulan_ini']['penyetoran'] !==0  ||
                resJSON.data.rekening[i]['kalkulasi']['bulan_ini']['sisa'] !==0  ||
                resJSON.data.rekening[i]['kalkulasi']['sd_bulan_ini']['penerimaan'] !==0  ||
                resJSON.data.rekening[i]['kalkulasi']['sd_bulan_ini']['penyetoran'] !==0  ||
                resJSON.data.rekening[i]['kalkulasi']['sd_bulan_ini']['sisa'] !==0){
                    tot1=tot1+resJSON.data.rekening[i].anggaran;
                }
                tot2=tot2+resJSON.data.rekening[i]['kalkulasi']['sd_bulan_lalu']['penerimaan'];
                tot3=tot3+resJSON.data.rekening[i]['kalkulasi']['sd_bulan_lalu']['penyetoran'];
                tot4=tot4+resJSON.data.rekening[i]['kalkulasi']['sd_bulan_lalu']['sisa'];
                tot5=tot5+resJSON.data.rekening[i]['kalkulasi']['bulan_ini']['penerimaan'];
                tot6=tot6+resJSON.data.rekening[i]['kalkulasi']['bulan_ini']['penyetoran'];
                tot7=tot7+resJSON.data.rekening[i]['kalkulasi']['bulan_ini']['sisa'];
                tot8=tot8+resJSON.data.rekening[i]['kalkulasi']['sd_bulan_ini']['penerimaan'];
                tot9=tot9+resJSON.data.rekening[i]['kalkulasi']['sd_bulan_ini']['penyetoran'];
                tot10=tot10+resJSON.data.rekening[i]['kalkulasi']['sd_bulan_ini']['sisa'];
            }
            this.setState({
                all_data: resJSON.data.rekening,
                opd: resJSON.data.opd,
                skpd: resJSON.data.skpd,
                requests: false,
                tot1: tot1,
                tot2: tot2,
                tot3: tot3,
                tot4: tot4,
                tot5: tot5,
                tot6: tot6,
                tot7: tot7,
                tot8: tot8,
                tot9: tot9,
                tot10: tot10,
                bulanSekarang: this.getBulan(moment().format("MM"))
            })
        })
    }

    getDataParaf(){
        fetch(`${BaseURLDev}/paraf`, { headers })
        .then(response => {
            if(!response.ok){
                return Promise.reject(response.statusText);
            }
            return response.json()
        })
        .then(resJSON => {
            const parafs = []
            resJSON.data.map((item,i)=>{
                parafs.push({
                'value': `${item.kode}`,
                'text': `${item.nama}`,
                'key': `${item.kode}`      
                })
                return false
            })
            this.setState({parafs:parafs})
            return false
        })
    }

    getDataKuasa(){
        fetch(`${BaseURLDev}/kuasa`, { headers })
        .then(response => {
            if(!response.ok){
                return Promise.reject(response.statusText);
            }
            return response.json()
        })
        .then(resJSON => {
            const kuasas = []
            resJSON.data.map((item,i)=>{
                kuasas.push({
                'value': `${item.jabatan}`,
                'text': `${item.nama}`,
                'key': `${item.kode}`      
                })
                return false
            })
            this.setState({kuasas:kuasas})
            return false
        })
    }

    componentDidMount(){
        // this.getAllData()
        this.getDataKuasa()
        this.getDataParaf()
        const bulan = [
            {"value":1,"text":"Januari","Key":1},
            {"value":2,"text":"Februari","Key":2},
            {"value":3,"text":"Maret","Key":3},
            {"value":4,"text":"April","Key":4},
            {"value":5,"text":"Mei","Key":5},
            {"value":6,"text":"Juni","Key":6},
            {"value":7,"text":"Juli","Key":7},
            {"value":8,"text":"Agustus","Key":8},
            {"value":9,"text":"September","Key":9},
            {"value":10,"text":"Oktober","Key":10},
            {"value":11,"text":"November","Key":11},
            {"value":12,"text":"Desember","Key":12},
        ]
        this.setState({ bulan: bulan })
    }
    exportDownload(){
        // window.location='/b/TemplateReport';
    }
    // exportData(){
    //     var pdf = new jsPDF('landscape');

    //     var specialElementHandlers = {
    //         'DIV to be rendered out': function(element, renderer){
    //          return true;
    //       }
    //     };
        
    //     var source = document.getElementById("print_data");
    //     pdf.autoTable({
    //         html: source
    //     });
    //     pdf.save(`${moment().format("DD_MM_YYYY_HH_mm_ss")}.pdf`);
    // }

    getBulan(e){
        if(e==='01') return 'Januari'
        else if(e==='02') return 'Februari'
        else if(e==='03') return 'Maret'
        else if(e==='04') return 'April'
        else if(e==='05') return 'Mei'
        else if(e==='06') return 'Juni'
        else if(e==='07') return 'Juli'
        else if(e==='08') return 'Agustus'
        else if(e==='09') return 'September'
        else if(e==='10') return 'Oktober'
        else if(e==='11') return 'November'
        else if(e==='12') return 'Desember'
    }

    exportData(){
        printJS({
            printable: 'print_data',
            type: 'html',
            modalMessage: "Sedang memuat data...",
            showModal:true,
            maxWidth: '1300',
            font_size: '8pt',
            documentTitle: 'Print SPJ Pendapatan - Administratif',
            targetStyle: [
                'margin',
                'color',
                'border-collapse',
                'border-spacing',
                'border-style',
                'border-style',
                'margin-bottom',
                'padding',
                'Label',
                'background'
            ]
        })
     }

    render() {
        const { requests, all_data, opd } = this.state;
        const styletb = {
            borderCollapse:'collapse',
            borderSpacing:0,
            borderStyle:'solid',
            width:'100%',
            fontSize:'10px'
        }
        return (
            <div>
                <Message
                    error
                    header='** Penting!'
                    content='Silahkan memilih Bulan untuk menampilkan data berdasarkan Bulan.'
                /> 
                <Menu>
                    <Menu.Item>
                        <Form.Field 
                            control={Select} 
                            search 
                            onChange={this.onChangeBulan} 
                            options={this.state.bulan} 
                            name="bulan" 
                            placeholder='Pilih Bulan'
                            title='Pilih Bulan'
                        /> 
                    </Menu.Item>
                    <Menu.Item>
                        <Form.Field 
                            control={Select} 
                            search 
                            onChange={this.onChangeKuasa} 
                            options={this.state.kuasas} 
                            name="kuasa" 
                            placeholder='Pilih KPA'
                            ttile='Pilih KPA'
                        />
                    </Menu.Item>
                    <Menu.Item>
                        <Form.Field 
                            control={Select} 
                            search 
                            onChange={this.onChangeParaf} 
                            options={this.state.parafs} 
                            name="paraf" 
                            placeholder='Pilih Bendahara Penerima'
                            ttile='Pilih Bendahara Penerima'
                        /> 
                    </Menu.Item>
                    <Menu.Item>
                        <Form.Input placeholder='Masukan Tempat' type='text' onChange={this.onChangeTempat}/>
                    </Menu.Item>
                    <Menu.Item position="right">
                        <Button color='blue' size="small" onClick={()=>this.exportData()}> 
                            <p><Icon name='print' className='left floated' />Preview</p>
                        </Button>
                    </Menu.Item>
                    
                </Menu>
                {
                requests ? <Loader active inline='centered' size='medium'>Loading...</Loader>:
                <Segment>
                    <div id="print_data">
                        <table align="center" width="100%" style={{fontSize:'10px'}}>
                            <tbody>
                                <tr align="center">
                                <th colSpan="2">
                                    <p style={{marginBottom: '25px'}}>PROVINSI NUSA TENGGARA BARAT<br />
                                    LAPORAN PERTANGGUNG JAWABAN BENDAHARA PENERIMA OPD<br />
                                    (SPJ PENDAPATAN-ADMINISTRATIF)
                                    </p>
                                </th>
                                </tr>
                            </tbody>
                        </table>
                        <table width="100%" style={{fontSize:'10px'}}>
                            <tbody>
                                <tr align="left" className="txt-left">
                                    <td className="txt-left" width="30%" align="left">OPD</td>
                                    <td className="txt-left" align="left">&nbsp;:&nbsp;{ (opd==="") ? "" : getOPD(opd) }</td>
                                </tr>
                                <tr align="left" className="txt-left">
                                    <td className="txt-left" width="30%" align="left">KPA</td>
                                    <td className="txt-left" align="left">&nbsp;:&nbsp;{this.state.kuasan}</td>
                                </tr>
                                <tr align="left" className="txt-left" >
                                    <td className="txt-left" width="30%" align="left">BENDAHARA PENERIMA</td>
                                    <td className="txt-left" align="left">&nbsp;:&nbsp;{this.state.parafn}</td>
                                </tr>
                                <tr align="left" className="txt-left">
                                    <td className="txt-left" width="30%" align="left">BULAN</td>
                                    <td className="txt-left" align="left">&nbsp;:&nbsp;{this.state.bulanSekarang+" "+moment().format("YYYY")}</td>
                                </tr>
                            </tbody>
                        </table>
                        <br/>
                        <table border="1" align="center" style={styletb} width="100%">
                            <tbody>            
                                <tr align="left" style={{background:'#e5e5e5',padding:'4px'}}>
                                    <th rowSpan="2" style={{padding:'4px',textAlign:'center'}}>Rekening</th>
                                    <th rowSpan="2" style={{padding:'4px',textAlign:'center'}}>Uraian</th>
                                    <th rowSpan="2" style={{padding:'4px',textAlign:'center'}}>Anggaran</th>
                                    <th colSpan="3" style={{padding:'4px',textAlign:'center'}}>Sampai Dengan Bulan Lalu</th>
                                    <th colSpan="3" style={{padding:'4px',textAlign:'center'}}>Bulan Ini</th>
                                    <th colSpan="3" style={{padding:'4px',textAlign:'center'}}>Sampai Dengan Bulan Ini</th>
                                </tr>
                                <tr align="left" style={{background:'#e5e5e5',padding:'4px'}}>
                                    <td style={{padding:'4px',textAlign:'center'}}>Penerimaan</td>
                                    <td style={{padding:'4px',textAlign:'center'}}>Penyetoran</td>
                                    <td style={{padding:'4px',textAlign:'center'}}>Sisa</td>

                                    <td style={{padding:'4px',textAlign:'center'}}>Penerimaan</td>
                                    <td style={{padding:'4px',textAlign:'center'}}>Penyetoran</td>
                                    <td style={{padding:'4px',textAlign:'center'}}>Sisa</td>

                                    <td style={{padding:'4px',textAlign:'center'}}>Penerimaan</td>
                                    <td style={{padding:'4px',textAlign:'center'}}>Penyetoran</td>
                                    <td style={{padding:'4px',textAlign:'center'}}>Sisa</td>
                                </tr>
                                <tr align="left" style={{background:'#e5e5e5',padding:'4px'}}>
                                    <td style={{padding:'4px',textAlign:'center'}}>1</td>
                                    <td style={{padding:'4px',textAlign:'center',width:"20%"}}>2</td>
                                    <td style={{padding:'4px',textAlign:'center'}}>3</td>
                                    <td style={{padding:'4px',textAlign:'center'}}>4</td>
                                    <td style={{padding:'4px',textAlign:'center'}}>5</td>
                                    <td style={{padding:'4px',textAlign:'center'}}>6=(5-4)</td>
                                    <td style={{padding:'4px',textAlign:'center'}}>7</td>
                                    <td style={{padding:'4px',textAlign:'center'}}>8</td>
                                    <td style={{padding:'4px',textAlign:'center'}}>9=(8-7)</td>
                                    <td style={{padding:'4px',textAlign:'center'}}>10=(4+7)</td>
                                    <td style={{padding:'4px',textAlign:'center'}}>11=(5+8)</td>
                                    <td style={{padding:'4px',textAlign:'center'}}>12=(11-10)</td>
                                </tr>
                                { 
                                    all_data.length === 0 && 
                                    <tr> <td colSpan="12" style={{padding:'4px',textAlign:'center'}}>Data Kosong</td> </tr> 
                                }
                                {all_data.map((item,i) => (
                                    (item.kalkulasi.sd_bulan_lalu.penerimaan===0 && item.kalkulasi.sd_bulan_lalu.penyetoran===0 &&
                                        item.kalkulasi.sd_bulan_lalu.sisa===0 && item.kalkulasi.bulan_ini.penerimaan===0 &&
                                        item.kalkulasi.bulan_ini.penyetoran===0 && item.kalkulasi.bulan_ini.sisa===0 &&
                                        item.kalkulasi.sd_bulan_ini.penerimaan===0 && item.kalkulasi.sd_bulan_ini.penyetoran===0 &&
                                        item.kalkulasi.sd_bulan_ini.sisa===0)? null:
                                    <tr key={i}>  
                                        <td style={{padding:'4px',textAlign:'center'}}>{ item.kode_rekening }</td>
                                        <td style={{padding:'4px',textAlign:'center',width:"10%"}}>{ item.nama_rekening }</td>
                                        <td align="right" style={{padding:'4px',textAlign:'center'}}>{ toIDR(item.anggaran) }</td>
                                        <td align="right" style={{padding:'4px',textAlign:'center'}}>{ (item.kalkulasi.sd_bulan_lalu.penerimaan!== 0)?
                                                toIDR(item.kalkulasi.sd_bulan_lalu.penerimaan) : "0" }</td>
                                        <td align="right" style={{padding:'4px',textAlign:'center'}}>{ (item.kalkulasi.sd_bulan_lalu.penyetoran!== 0)?
                                            toIDR(item.kalkulasi.sd_bulan_lalu.penyetoran) : "0"}</td>
                                        <td align="right" style={{padding:'4px',textAlign:'center'}}>{ (item.kalkulasi.sd_bulan_lalu.sisa!== 0)?
                                            toIDR(item.kalkulasi.sd_bulan_lalu.sisa) : "0"}</td>
                                        <td align="right" style={{padding:'4px',textAlign:'center'}}>{ (item.kalkulasi.bulan_ini.penerimaan!== 0)?
                                            toIDR(item.kalkulasi.bulan_ini.penerimaan) : "0"}</td>
                                        <td align="right" style={{padding:'4px',textAlign:'center'}}>{ (item.kalkulasi.bulan_ini.penyetoran!== 0)?
                                            toIDR(item.kalkulasi.bulan_ini.penyetoran) : "0"}</td>
                                        <td align="right" style={{padding:'4px',textAlign:'center'}}>{ (item.kalkulasi.bulan_ini.sisa!== 0)?
                                            toIDR(item.kalkulasi.bulan_ini.sisa) : "0"}</td>
                                        <td align="right" style={{padding:'4px',textAlign:'center'}}>{ (item.kalkulasi.sd_bulan_ini.penerimaan!== 0)?
                                            toIDR(item.kalkulasi.sd_bulan_ini.penerimaan) : "0"}</td>
                                        <td align="right" style={{padding:'4px',textAlign:'center'}}>{ (item.kalkulasi.sd_bulan_ini.penyetoran!== 0)?
                                            toIDR(item.kalkulasi.sd_bulan_ini.penyetoran) : "0"}</td>
                                        <td align="right" style={{padding:'4px',textAlign:'center'}}>{ (item.kalkulasi.sd_bulan_ini.sisa!== 0)?
                                            toIDR(item.kalkulasi.sd_bulan_ini.sisa) : "0"}</td>
                                    </tr> 
                                ))}
                                <tr align="left" style={{background:'#e5e5e5',padding:'4px'}}>
                                    <td colSpan="2" style={{padding:'4px',textAlign:'right'}}>JUMLAH</td>
                                    <td align="right" style={{padding:'4px',textAlign:'right'}}>{ (this.state.tot1 !==0)?
                                        toIDR(this.state.tot1): "0"}</td>
                                    <td align="right" style={{padding:'4px',textAlign:'right'}}>{ (this.state.tot2 !==0)?
                                        toIDR(this.state.tot2): "0"}</td>
                                    <td align="right" style={{padding:'4px',textAlign:'right'}}>{ (this.state.tot3 !==0)?
                                        toIDR(this.state.tot3): "0"}</td>
                                    <td align="right" style={{padding:'4px',textAlign:'right'}}>{ (this.state.tot4 !==0)?
                                        toIDR(this.state.tot4): "0"}</td>
                                    <td align="right" style={{padding:'4px',textAlign:'right'}}>{ (this.state.tot5 !==0)?
                                        toIDR(this.state.tot5): "0"}</td>
                                    <td align="right" style={{padding:'4px',textAlign:'right'}}>{ (this.state.tot6 !==0)?
                                        toIDR(this.state.tot6): "0"}</td>
                                    <td align="right" style={{padding:'4px',textAlign:'right'}}>{ (this.state.tot7 !==0)?
                                        toIDR(this.state.tot7): "0"}</td>
                                    <td align="right" style={{padding:'4px',textAlign:'right'}}>{ (this.state.tot8 !==0)?
                                        toIDR(this.state.tot8): "0"}</td>
                                    <td align="right" style={{padding:'4px',textAlign:'right'}}>{ (this.state.tot9 !==0)?
                                        toIDR(this.state.tot9): "0"}</td>
                                    <td align="right" style={{padding:'4px',textAlign:'right'}}>{ (this.state.tot10 !==0)?
                                        toIDR(this.state.tot10): "0"}</td>
                                </tr>
                            </tbody>            
                        </table>
                        
                        <table width="100%" style={{marginTop:'30px',fontSize:'10px'}}>
                            <tbody>
                            <tr>
                                <td align="center">
                                {
                                    (this.state.kuasa==="")? null :
                                    <b>Mengetahui <br/> {this.state.kuasaj} <br/><br/><br/>{this.state.kuasan}<br/>NIP. {this.state.kuasa}</b>
                                }
                                </td>
                                <td align="center">
                                {
                                    (this.state.parafn==="")? null : 
                                    <b>{this.state.tempat}, {moment().format("DD")+" "+this.getBulan(moment().format("MM"))+" "+moment().format("YYYY")} 
                                    <br/> Bendahara Penerima <br/><br/><br/>{this.state.parafn}<br/>NIP. {this.state.paraf}</b>
                                }
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </Segment>
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Content/views/opd/_report/SPJPendapatan.js